import { uniqBy } from "lodash";
import { store } from "redux/store";
import { DEFAULT_CORP_INNCODE } from "utils/CommonConstants";
import { filterPage, getKeyValue } from "./FiltersHelper";

const filterRegionFilter = (state: any) => {
  const { propertyList } = state.aboveProperty;
  const filteredRegion = uniqBy(
    propertyList
      ?.filter((data: any) => data.subRegion)
      .map((data: any) => ({
        key: data.subRegion,
        value: data.subRegion
      })),
    "key"
  );
  return filteredRegion ?? [];
};

export const getDynamicFiltersOptions = (filterKey: string) => {
  const state: any = store.getState();
  switch (filterKey) {
    case "brandCode": {
      return state.myplans.MyPlans.brands;
    }
    case "brandCodes": {
      const brandsList = getKeyValue(state?.aboveProperty?.brands, "brandCode", "brandName");
      return brandsList;
    }
    case "initiativeNames": {
      const initiativeFilters = getKeyValue(state?.aboveProperty?.initiativeFilterValues, "name", "name");
      return initiativeFilters;
    }
    case "regions": {
      return filterRegionFilter(state);
    }
    case "innCode": {
      return state.planDetails.planDetails?.meta?.innCodes;
    }
  }
};

export const shouldShowFilterCallback = (page: string) => {
  const state = store.getState();

  switch (page) {
    case filterPage.libraryAllPlansDisplay:
    case filterPage.libraryAllPlansSearchDisplay:
    case filterPage.libraryBookmarkedPlansDisplay:
    case filterPage.libraryFunctionalAreasDisplay:
    case filterPage.libraryAllPlansSearchIndividualActionsDisplay:
    case filterPage.libraryFunctionalAreasIndividualActionsDisplay:
      return state.app.innCode === DEFAULT_CORP_INNCODE;
    default:
      return false;
  }
};
